/**
 * Maps a raw API row from the task-02 JSON contract to a typed view-model.
 *
 * All nullable API fields are explicitly handled; derived booleans/counts are
 * computed here so components never need to repeat the logic.
 */
export function mapApiRowToViewModel(row) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        id: row.id,
        number: row.number,
        question: row.question,
        answer: row.answer,
        dateOpened: (_a = row.dateOpened) !== null && _a !== void 0 ? _a : null,
        systemLabel: row.systemLabel,
        assetDetails: (_b = row.assetDetails) !== null && _b !== void 0 ? _b : {},
        details: row.details,
        severity: (_c = row.severity) !== null && _c !== void 0 ? _c : null,
        resolutionStatus: (_d = row.resolutionStatus) !== null && _d !== void 0 ? _d : null,
        photoCount: row.photoCount,
        includedPhotoIds: row.includedPhotoIds,
        thumbnailUrl: (_e = row.thumbnailUrl) !== null && _e !== void 0 ? _e : null,
        section: (_f = row.section) !== null && _f !== void 0 ? _f : null,
        photos: (_g = row.photos) !== null && _g !== void 0 ? _g : [],
        includedCount: ((_h = row.includedPhotoIds) !== null && _h !== void 0 ? _h : []).length,
        hasPhotos: row.photoCount > 0
    };
}
